export default {
  async setLabels({ state, commit, error, rootState }) {
    if (!state.labels[this.$i18n.locale]) {
      commit('setStatus', false, { root: true })
      await this.$apiContent
        .getLabels()
        .then((result) => {
          this.$i18n.setLocaleMessage(this.$i18n.locale, result)
          commit('setLabels', result)
          commit('SET_LOADED', { type: 'labels', value: true }, { root: true })
        })
        .catch((e) => {
          commit('SET_LOADED', { type: 'labels', value: true }, { root: true })
          window.$nuxt.error({
            statusCode: e.statusCode, // Hay que saber que devuelve la API en los errores
            message: e.message
          })
        })
    } else {
      commit('SET_LOADED', { type: 'labels', value: true }, { root: true })
    }
  }
}
